var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUpSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84756 0.390472C6.37901 -0.130157 5.61807 -0.130157 5.14952 0.390472L0.35152 5.72172C0.0066639 6.10491 -0.0945439 6.67552 0.0928779 7.17532C0.2803 7.67513 0.715118 8 1.20242 8H10.7984C11.282 8 11.7205 7.67513 11.908 7.17532C12.0954 6.67552 11.9904 6.10491 11.6493 5.72172L6.85131 0.390472H6.84756Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUpSolid);
export default __webpack_public_path__ + "static/media/caret-up-solid.b2d7922d34cbf1f5632b7be313ab2516.svg";
export { ForwardRef as ReactComponent };